/*
 * Purpose: User Support page — in-app help (100% user-facing coverage)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 98
 */
import { useSearchParams } from 'react-router-dom';
import { UserSupportCenter } from '@/components/support/UserSupportCenter';
import { PageMotion } from '@/components/motion/PageMotion';
import { PRODUCT_TERMS } from '@/lib/productTerms';

export default function Help() {
  const [params] = useSearchParams();
  const defaultTab = params.get('tab') ?? 'getting-started';

  return (
    <PageMotion variant="body">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8 space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Support — workflow automation help</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Guides for {PRODUCT_TERMS.productName}: compose, connect, run, and migrate from Zapier, Make, or n8n.
          </p>
        </div>
        <UserSupportCenter defaultTab={defaultTab} />
      </div>
    </PageMotion>
  );
}
